import { render } from "./mvt-select.vue?vue&type=template&id=0f66908f"
import script from "./mvt-select.js?vue&type=script&lang=js"
export * from "./mvt-select.js?vue&type=script&lang=js"

import "./mvt-select.vue?vue&type=style&index=0&id=0f66908f&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__